import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { adminGetDashboardModelsStatsDataApi } from '../../../api/dashboard/adminGetDashboardModelsStatsDataApi';
import { AdminDashboardDataFilter, AdminDashboardModelsStatsResponse } from '../../../graphql/API';

export const useAdminGetDashboardModelsStatsDataQuery = (
  filter: AdminDashboardDataFilter,
): UseQueryResult<AdminDashboardModelsStatsResponse, Error> => {
  const adminGetDashboardModelsStatsDataQuery = useQuery({
    queryKey: ['admin-get-dashboard-models-data-stats', filter],
    queryFn: async ({ queryKey }) => {
      const [, filter] = queryKey as [string, AdminDashboardDataFilter];
      const response = await adminGetDashboardModelsStatsDataApi(filter);
      return response;
    },
    enabled: !!filter.fromDate || !!filter.toDate || !!filter.priorFromDate || !!filter.priorToDate,
  });
  return { ...adminGetDashboardModelsStatsDataQuery };
};
